<script lang="ts">
  type $$Props = svelteHTML.HTMLProps<'button', {}> & {
    onclick?: (e: MouseEvent) => void;
  };

  export let onclick: (e: MouseEvent) => void = () => {};
</script>

<button {...$$restProps} on:click={onclick}>
  <div><slot /></div>
</button>

<style lang="scss">
  button {
    transition: 200ms;
    appearance: none;
    border: none;
    background: var(--secondary-bg);
    display: flex;
    height: fit-content;
    font-size: 120%;
    width: fit-content;
    padding: 0.7rem 1.5rem 0.8rem;
    border-radius: 2rem;
    text-decoration: none;
    color: white;
    font-weight: bold;
    margin: 0.5rem auto;

    &:disabled {
      background: var(--disabled);
      pointer-events: none;
    }

    &:hover {
      filter: brightness(1.2);
    }

    &:active {
      filter: brightness(0.8);
    }

    div {
      margin: auto;
    }
  }
</style>
